import { render, staticRenderFns } from "./page-sleep-stories.vue?vue&type=template&id=067fd216&scoped=true"
import script from "./page-sleep-stories.vue?vue&type=script&lang=ts"
export * from "./page-sleep-stories.vue?vue&type=script&lang=ts"
import style0 from "./page-sleep-stories.vue?vue&type=style&index=0&id=067fd216&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067fd216",
  null
  
)

export default component.exports